import { jsx as _jsx } from "react/jsx-runtime";
import {} from 'react';
import { Toaster as SonnerToaster, toast } from 'sonner';
import { cn } from '../lib/utils.js';
export { toast };
// Map Sonner's per-type CSS variables onto the admin @theme tokens so toasts
// read as part of the design system (soft tint + semantic accent per type).
const themeVars = {
    '--normal-bg': 'var(--color-surface)',
    '--normal-border': 'var(--color-line-strong)',
    '--normal-text': 'var(--color-ink)',
    '--success-bg': 'var(--color-success-soft)',
    '--success-border': 'var(--color-success)',
    '--success-text': 'var(--color-success)',
    '--error-bg': 'var(--color-danger-soft)',
    '--error-border': 'var(--color-danger)',
    '--error-text': 'var(--color-danger)',
    '--warning-bg': 'var(--color-warn-soft)',
    '--warning-border': 'var(--color-warn)',
    '--warning-text': 'var(--color-warn)',
    '--info-bg': 'var(--color-accent-soft)',
    '--info-border': 'var(--color-accent)',
    '--info-text': 'var(--color-accent)',
};
/**
 * Toaster — Sonner toaster themed to the admin design system. Mount once at the
 * app root; fire toasts imperatively with the exported `toast` helper (covers
 * publish / settle / void action feedback). `richColors` + the mapped CSS vars
 * give each toast type its admin tint.
 */
export function Toaster({ className, position = 'bottom-right', style, ...props }) {
    return (_jsx(SonnerToaster, { theme: "light", richColors: true, position: position, className: cn('font-ui', className), style: { ...themeVars, ...style }, toastOptions: {
            classNames: {
                toast: 'rounded-card border-[0.5px] font-ui shadow-card',
                title: 'font-ui text-[13px] font-semibold tracking-[-0.005em]',
                description: 'font-ui text-[12.5px] leading-[1.45]',
                actionButton: 'rounded-pill font-ui text-[12px] font-medium',
                cancelButton: 'rounded-pill font-ui text-[12px] font-medium',
            },
        }, ...props }));
}
//# sourceMappingURL=toaster.js.map